import { SeoHeadOptions } from '~/models/GeneralModels'

const DEFAULT_TITLE_POSTFIX = ' | idioma®'

const defaultHeadOptions: SeoHeadOptions = {
  Title: null,
  Description: '',
  TitlePostfix: '',
  UseDefaultTitlePostfix: false
}

export const createHead = (options: SeoHeadOptions = defaultHeadOptions) => {
  options = Object.assign({}, defaultHeadOptions, options)
  const titlePostfix = options.UseDefaultTitlePostfix
    ? DEFAULT_TITLE_POSTFIX
    : options.TitlePostfix
  const title = options.Title + titlePostfix

  const description = options.Description ? options.Description : null

  return {
    title,
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: description
      }
    ]
  }
}
